var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
    stroke: "#666D80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.8999C7.41421 10.8999 7.75 10.5641 7.75 10.1499C7.75 9.73569 7.41421 9.3999 7 9.3999C6.58579 9.3999 6.25 9.73569 6.25 10.1499C6.25 10.5641 6.58579 10.8999 7 10.8999Z",
    fill: "#666D80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3457 4.82117C5.5989 3.85637 6.3855 3.35717 7.2663 3.40277C8.1363 3.44777 8.9457 3.92597 8.9085 5.03597C8.8551 6.61397 7.1781 6.39977 6.9903 7.89977H6.9969",
    stroke: "#666D80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.d00747c43ac040d7d41e91aac3184747.svg";
export { ForwardRef as ReactComponent };